import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form } from 'antd'
import { langList } from '../../../factories/Utils'
import { requiredRule } from '../../../utils/rules'
import AttachmentEditor from '../../AttachmentEditor'
import { Localizable } from '../../localizable/Localizable'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  return (
    <Form {...formProps} form={form} layout="vertical">
      <Localizable.Input
        name="label"
        rules={[requiredRule()]}
        label={'Name'}
        max={20}
      />
      {langList.map((lang) => (
        <AttachmentEditor
          dragger={{ fileTypes: ['pdf'] }}
          label={`${lang.flag} ${lang.name} attachment (required)`}
          formItem={{ name: [lang.code, 'file'], rules: [requiredRule()] }}
        />
      ))}
    </Form>
  )
}

export default Create
